import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-zixun",
  "use": "icon-zixun-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-zixun\"><defs><style>#icon-zixun .cls-1{fill:#004727;}</style></defs><path class=\"cls-1\" d=\"M12,.85a10,10,0,0,1,10.22,9.74,9.68,9.68,0,0,1-5.35,8.57c-1.58.8-4.26,2.13-8,4V19.86a9.79,9.79,0,0,1-7.08-9.27A10,10,0,0,1,12,.85ZM6.73,11.21a1.11,1.11,0,0,0,0,1.58,7.57,7.57,0,0,0,10.54,0,1.1,1.1,0,0,0,0-1.58,1.14,1.14,0,0,0-1.57,0,5.25,5.25,0,0,1-7.33,0h0A1.17,1.17,0,0,0,6.73,11.21Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol